function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "icon-rebalance");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "icon-rebalance",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fillOpacity: 0.195940778,
  fill: "#43BFBF",
  cx: 20,
  cy: 20,
  r: 20
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.9741572,15.0769231 L20,15.0769231 C16.4854607,15.0769231 13.6363636,17.8493139 13.6363636,21.2692308 C13.6363636,24.6891477 16.4854607,27.4615385 20,27.4615385 C23.5145393,27.4615385 26.3636364,24.6891477 26.3636364,21.2692308 C26.3636364,20.292112 27.1776641,19.5 28.1818182,19.5 C29.1859718,19.5 30,20.292112 30,21.2692308 C30,26.643386 25.5228475,31 20,31 C14.4771525,31 10,26.643386 10,21.2692308 C10,15.8950755 14.4771525,11.5384615 20,11.5384615 L21.9741572,11.5384615 L21.441624,11.0202662 C20.7315799,10.3293383 20.7315799,9.20912327 21.441624,8.51819531 C22.1516682,7.82726823 23.3028773,7.82726823 24.0129215,8.51819531 L27.6492851,12.0566568 C28.3593292,12.7475848 28.3593292,13.8677998 27.6492851,14.5587278 L24.0129215,18.0971893 C23.3028773,18.7881164 22.1516682,18.7881164 21.441624,18.0971893 C20.7315799,17.4062613 20.7315799,16.2860463 21.441624,15.5951184 L21.9741572,15.0769231 Z",
  id: "Path",
  fill: "#268080",
  fillRule: "nonzero"
})));

var SvgRebalance = function SvgRebalance(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRebalance, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/rebalance.ecac0f6a.svg";
export { ForwardRef as ReactComponent };